// EndPoint names for the Loan-Enquiry open-module
export default {

  apiRoot: 'api/loan-enquiry/',

  // Actions
  LOAN_ENQUIRY_CONFIGURATION_READ: 'configuration',
  LOAN_ENQUIRY_CHECK_ELIGIBILITY: 'eligibility',
  LOAN_ENQUIRY_OTP_REQUEST: 'otp-request',
  LOAN_ENQUIRY_OTP_VALIDATE: 'otp-validate',
  LOAN_ENQUIRY_CREATE: 'create',
  LOAN_ENQUIRY_GENERATE_SIGNATURE: 'hash',
  
  LOAN_ENQUIRY_REQUEST_OPEN: 'request-open',
  LOAN_ENQUIRY_OPEN_ENQUIRY: 'open-enquiry',
  LOAN_ENQUIRY_ENQUIRY_DOCUMENT: 'enquiry-document',
  LOAN_ENQUIRY_ENQUIRY_ID_VERIFICATION: 'enquiry-id-verification',
};
